import usePanic from "./usePanic";

export default usePanic;